import React, { useContext } from 'react';
import { AppContext } from '../App';
import Header from '../components/Header';
import LoadingState from '../components/LoadingState';
import HeroStats from '../components/dashboard/HeroStats';
import MarketPulse from '../components/dashboard/MarketPulse';
import TopModelsTable from '../components/dashboard/TopModelsTable';
import RegionalHeatmap from '../components/dashboard/RegionalHeatmap';
import DemographicsGrid from '../components/dashboard/DemographicsGrid';
import PredictionsPanel from '../components/dashboard/PredictionsPanel';
import AIInsightsPanel from '../components/dashboard/AIInsightsPanel';
import NewsSection from '../components/dashboard/NewsSection';
import TrendingSearches from '../components/dashboard/TrendingSearches';

const Dashboard = () => {
  const { loading } = useContext(AppContext);

  if (loading) {
    return <LoadingState />;
  }

  return (
    <div className="min-h-screen bg-[#09090B]" data-testid="dashboard-container">
      <Header />
      <main className="max-w-[1800px] mx-auto px-4 md:px-6 lg:px-8 py-6 space-y-8">
        {/* Hero Stats Row */}
        <HeroStats />
        
        {/* Market Pulse - Multi-metric visualization */}
        <MarketPulse />
        
        {/* Two Column: Top Models + AI Insights */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2">
            <TopModelsTable />
          </div>
          <div className="lg:col-span-1">
            <AIInsightsPanel />
          </div>
        </div>
        
        {/* Regional Opportunities */}
        <RegionalHeatmap />
        
        {/* Demographics + Trending */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <DemographicsGrid />
          <TrendingSearches />
        </div>
        
        {/* Predictions + News */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <PredictionsPanel />
          <NewsSection />
        </div>
        
        {/* Footer */}
        <footer className="text-center py-8 border-t border-[#27272A]">
          <p className="text-[#52525B] text-sm">
            VehicleIQ Canadian Market Intelligence • Data refreshes every 15 minutes
          </p>
        </footer>
      </main>
    </div>
  );
};

export default Dashboard;
